import {CustomerFilterLanguage} from 'src/app/core/class/customer-filter-language';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  ElementRef,
  HostListener
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from 'src/app/core/services/common.service';
import {CustomerService} from 'src/app/core/services/customer.service';
import {Subscription} from 'rxjs/internal/Subscription';
import {NotificationService} from 'src/app/core/services/notification.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {ActivatedRoute, Router} from '@angular/router';
import {NgForm, FormControl} from '@angular/forms';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {UploadMultiFileComponent} from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import {map, first, takeUntil, finalize} from 'rxjs/operators';
import {BreadcrumbsService} from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import {DeactivationGuarded} from 'src/app/core/guards/confirm-deactivate.guard';
import {MatAccordion, MatDatepickerInputEvent, MatSelect, MatTabGroup} from '@angular/material';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {EnterpriseTypes} from 'src/app/core/constants/enterprise-type';
import {Subject, ReplaySubject, BehaviorSubject} from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Common } from '../../../../../../../core/constants/common';
import { DateParseService } from 'src/app/core/services/date-parse.service';

@Component({
  selector: 'app-update-customer',
  templateUrl: './update-customer.component.html',
  styleUrls: ['./update-customer.component.scss']
})
export class UpdateCustomerComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  // set max date for birthday
  @BlockUI() blockUI: NgBlockUI;
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  @ViewChild(UploadMultiFileComponent, {read: UploadMultiFileComponent, static: false}) uploadMultiFileComponent;
  currentTab = 0
  dataImage = []
  originGroupIds = [];
  groupCustomerIds = [];
  customer = {
    id: null,
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: 0,
    name: '',
    status: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    adminUser: '',
    attachmentImages: [],
    customerGroupIdAdds: [],
    customerGroupIdRemoves: [],
    groupCustomerIds: [],
    customerCode: null,
    isNewAddress: true
  };
  isInforTab = 0
  oldCustomerName = "";
  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  selectedDistricts: districtsComboBox[] = [];
  wards: wardsCombobox[] = [];
  selectWards: wardsCombobox[] = [];
  isShowInfor: boolean = true
  checkFocus = false;
  show = true;
  change = false;
  error = '';
  subscription: Subscription;
  attachments: any[];
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchEnterpriseId: '';
  searchTaxCodeOrCertificateNo: '';
  searchKeyword: '';
  searchStatus: [];
  searchEnterpriseTypeId: number;

  enterpriseType: comboBox[] = [];
  certificateType: comboBox[] = [];
  representativeCertificateType: comboBox[] = [];
  listBankName: comboBox[] = [];

  enterpriseTypeFilterCtrl: FormControl = new FormControl();
  certificationTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl();
  cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();
  isNotAttestedUser: boolean = false;
  bankFilterCtrl: FormControl = new FormControl();

  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificationType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();
  public filteredBankName: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  oldCustomerType: any = 0;
  personalId = EnterpriseTypes.PERSONAL;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChild('enterpriseTypeSelect', {static: false}) enterpriseTypeSelect: MatSelect;
  @ViewChild('certificationTypeSelect', {static: false}) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', {static: false}) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', {static: false}) citySelect: MatSelect;
  @ViewChild('districtSelect', {static: false}) districtSelect: MatSelect;
  @ViewChild('wardSelect', {static: false}) wardSelect: MatSelect;
  @ViewChild('sexSelect1', {static: false}) sexSelect1: MatSelect;
  @ViewChild('sexSelect2', {static: false}) sexSelect2: MatSelect;
  @ViewChild('accordion', {static: false}) accordion: MatAccordion;
  @ViewChild('myTabGroup', {static: false}) myTabGroup: MatTabGroup;
  @ViewChild('bankSelect', { static: false }) bankSelect: MatSelect;

  public loadStatusDistrict = new BehaviorSubject(false);
  public loadStatusWard = new BehaviorSubject(false);

  formChangesSubscription: Subscription;
  isFormChanging = false;
  userType: any;
  permissions: any
  listImage = [];
  isImagesChanging = false;
  /**
   * Check if District hasn't Ward
   */
  notHasWard = false;
  scopeType:number;
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  cityList: any[] = []
  districtList: any[] = []
  wardList: any[] = []
  isDisableMST: boolean = true;
  isDisableLGT: boolean = true;

  constructor(
    private el: ElementRef,
    public commonService: CommonService,
    private customerService: CustomerService,
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    public customerFilter: CustomerFilterLanguage
  ) {
    super(commonService, message);
    this.customer.id = this.route.snapshot.paramMap.get('id');
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.userType = Number(localStorage.getItem("userType"));
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    // this.loadCities();
    // this.loadDistricts();
    // this.loadWards();
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl, this.filteredEnterpriseType);
    });
    this.certificationTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.certificateType, this.certificationTypeFilterCtrl, this.filteredCertificationType);
    });
    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.representativeCertificateType, this.representativeCertificateTypeFilterCtrl, this.filteredRepresentativeCertificateType);
    });
    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity);
    });
    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl, this.filteredDistricts);
    });
    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl, this.filteredWard);
    });
    this.bankFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.commonService.filterCertificateType(this.listBankName, this.bankFilterCtrl, this.filteredBankName);
    });
    this.getBankName();
    this.getEnterpriseType();
    this.getCertificateType();
    this.getRepresentativeCertificateType();

    this.commonService.getCategory().subscribe(result => {
      this.cityList[1] = result[0].data.filter(item => !item.isNew)
      this.districtList[1] = result[1].data.filter(item => !item.isNew)
      this.wardList[1] = result[2].data.filter(item => !item.isNew)
      this.cityList[0] = result[3].data
      this.districtList[0] = []
      this.wardList[0] = result[4].data;

      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.filteredCity.next(this.cities.slice());
      this.getCustomer(this.customer.id);
    })
    // this.getCustomer(this.customer.id);
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      {label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false},
      {label: 'breadcrumbs.management_customer', url: '', params: [], highlight: false},
      {label: 'breadcrumbs.enterprise_customer', url: 'customers', params: [], highlight: false},
      {label: 'breadcrumbs.customer_update', url: 'update-customer/:id', params: [this.customer.id], highlight: false},
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        // this.page = +params['page'] || 0;
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchEnterpriseId = params.enterpriseId || '';
        this.searchKeyword = params.keyword || '';
        this.searchEnterpriseTypeId = params.enterpriseTypeId;
        this.searchStatus = params.status;
        this.searchTaxCodeOrCertificateNo = params.taxCodeOrCertificateNo || '';
      });
  }

  ngAfterViewInit() {
    setTimeout(_ => document.getElementById('focusSelect').focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.commonService.getAllCityRedis().subscribe(rs => {
      this.cities = rs.data;
      localStorage.setItem(
        'cities',
        JSON.stringify(this.cities),
      );
      this.filteredCity.next(this.cities.slice());
    });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.commonService.getAllDistrictsRedis().subscribe(rs => {
      this.districts = rs.data;
      localStorage.setItem(
        'districts',
        JSON.stringify(this.districts),
      );
    });
    // this
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.commonService.getAllWardRedis().subscribe(rs => {
      this.wards = rs.data;
      localStorage.setItem(
        'wards',
        JSON.stringify(this.wards),
      );
    });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  /**
   * Call api to get customer by id
   * @param id: number
   */
  getCustomer(id: number) {
    this.customerService.getCustomer(id).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.customer = {
          ...this.customer,
          ...rs.data,
          issuedDate: rs.data.issuedDate != null ? DateParseService.parseDate(rs.data.issuedDate) : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? DateParseService.parseDate(rs.data.representativeIssuedDate) : null,
          birthday: rs.data.birthday != null ? DateParseService.parseDate(rs.data.birthday) : null
        };
        this.isDisableMST = !!this.customer.taxCode
        this.isDisableLGT = !!this.customer.certificateId
        this.dataImage = this.customer.attachmentImages;
        this.oldCustomerName = this.customer.name;
        this.oldCustomerType = this.customer.customerType;
        this.customer.isNewAddress = !!rs.data.isNewAddress
        if(this.customer.isNewAddress){
          this.cities = this.cityList[0]
          this.districts = this.districtList[0]
          this.wards = this.wardList[0]
        } else {
          this.cities = this.cityList[1]
          this.districts = this.districtList[1]
          this.wards = this.wardList[1]
        }
        this.filteredCity.next(this.cities.slice());
        if (!this.customer.isNewAddress) {
          if (this.customer.wardId === undefined || this.customer.wardId == null || this.customer.districtId === undefined || this.customer.districtId == null) {
            this.selectedDistricts = this.districts.filter(x => {
              return x.cityId == this.customer.cityId;
            });
            this.filteredDistricts.next(this.selectedDistricts.slice());
            if(this.customer.districtId === undefined || this.customer.districtId == null){
              this.customer.districtId = null;
            }
            else {
              this.selectWards = this.wards.filter(x => {
                return x.districtId == this.customer.districtId;
              });
              this.filteredWard.next(this.selectWards.slice());
            }
            if(this.customer.wardId === undefined || this.customer.wardId == null){
              this.customer.wardId = null;
            }
          } else {
            this.selectedDistricts = this.districts.filter(x => {
              return x.cityId == this.customer.cityId;
            });
            this.filteredDistricts.next(this.selectedDistricts.slice());
            this.selectWards = this.wards.filter(x => {
              return x.districtId == this.customer.districtId;
            });
            this.filteredWard.next(this.selectWards.slice());
          }
        } else {
          this.selectWards = this.wards.filter(x => {
            return  x.cityId == this.customer.cityId;
          });
          this.filteredWard.next(this.selectWards.slice());
        }
        this.attachments = [...this.customer.attachments];
      }
    );
  }

  /**
   * Detect change on city or district combobox
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.customer.districtId = null;
          this.customer.wardId = null;
          return x.cityId == value;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.customer.wardId = null;
          if(this.customer.isNewAddress){
            return x.cityId === value;
          } else {
            return x.districtId === value;
          }
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  addAttachments(dialogRe) {
    this.uploadMultiFileComponent.uploadFile((attachments) => {
      this.customer.attachments = attachments;
      this.updateCustomer(dialogRe);
    }, () => {
      this.updateCustomer(dialogRe);
    });
  }

  imageUpload($event) {
    this.listImage = $event;
    this.isImagesChanging = true;
    this.isFormChanging = true;
  }

  /**
   * On click button update customer
   */
  onUpdateCustomer() {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.commonService.format(this.message.getMessage('messages.confirm_update_customer'), this.oldCustomerName)
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          let attachmentImages = []
          if (this.listImage && this.listImage.length) {
            attachmentImages = this.listImage.filter(item => {
              if (item.fileContentBase64) {
                return item
              }
            })
          }
          if (attachmentImages && attachmentImages.length) {
            this.customerService.uploadImage(attachmentImages).subscribe(res => {
              if (res && res.success) {
                this.customer.attachmentImages = res.data
                this.addAttachments(dialogRe);
              } else {
                this.toastr.error(res.message)
              }
            })
          } else if (this.isImagesChanging && attachmentImages.length == 0) {
            this.customer.attachmentImages = []
            this.addAttachments(dialogRe);
          } else {
            this.addAttachments(dialogRe);
          }
        }
      });
    } else {
      this.router.navigate(['/home-enterprise/customers'], {
        queryParams: {
          tenantId: this.searchtenantId,
          page: this.searchPage,
          pageSize: this.searchPageSize,
          enterpriseId: this.searchEnterpriseId,
          taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
          keyword: this.searchKeyword,
          status: this.searchStatus,
          enterpriseTypeId: this.searchEnterpriseTypeId
        }
      });
    }
    this.checkExistCustomerCode()
  }

  checkExistCustomerCode() {
    this.notificationService.getErrorCode().subscribe(res=>{
      if(res == '0x00133'){
        this.existedCustomerCode();
        return
      }
    });
  }

  /**
   * Call update customer service and push data to server.
   * @param dialogRe: Dialog result confirmation.
   */
  private updateCustomer(dialogRe) {
    this.customer.customerGroupIdRemoves = this.customer.groupCustomerIds.filter((item) => !this.groupCustomerIds.includes(item)) || [];
    this.customer.customerGroupIdAdds = this.groupCustomerIds.filter((item) => !this.customer.groupCustomerIds.includes(item)) || [];
    this.customerService.updateCustomer(
      this.customer,
      () => {
        this.show = false;
        this.toastr.success(this.message.getMessage('messages.update_success'));
        dialogRe.close();
        this.router.navigate(['/home-enterprise/customers'], {
          queryParams: {
            tenantId: this.searchtenantId,
            page: this.searchPage,
            pageSize: this.searchPageSize,
            enterpriseId: this.searchEnterpriseId,
            taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
            keyword: this.searchKeyword,
            status: this.searchStatus,
            enterpriseTypeId: this.searchEnterpriseTypeId
          }
        });
      },
      () => {
        this.getCustomer(this.customer.id);
      },
      this.onUpdateCustomerError.bind(this)
    );
  }

  private onUpdateCustomerError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x00118':
          this.certificateNoExistingHanlder();
          break;
        case '0x00117':
          this.taxNoExistingHanlder();
          break;
        case '0x00133':
          this.existedCustomerCode();
          break;
        default: {
          this.toastr.error(rs.message)
        }
      }
    }
  }

  private certificateNoExistingHanlder(): void {
    if (this.customer.customerType == this.personalId) {
      this.ngForm.form.controls.certificateNo1.setErrors({duplicate: true});
      document.getElementById('certificateNo1').focus();
    } else {
      this.ngForm.form.controls.certificateNo.setErrors({duplicate: true});
      document.getElementById('certificateNo').focus();
    }

  }

  private existedCustomerCode(): void {
     if (this.customer.customerCode == this.personalId) {
       this.ngForm.form.controls.customerCode.setErrors({duplicate: true});
       document.getElementById('customerCode').focus();
     } else {
       this.ngForm.form.controls.customerCode.setErrors({duplicate: true});
       document.getElementById('customerCode').focus();
     }
  }

  private taxNoExistingHanlder(): void {
    this.ngForm.form.controls.taxCode.setErrors({duplicate: true});
    document.getElementById('taxCode').focus();
  }

  /**
   * Back to list customers
   */
  onNoClick(): void {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.router.navigate(['/home-enterprise/customers'], {
            queryParams: {
              tenantId: this.searchtenantId,
              page: this.searchPage,
              pageSize: this.searchPageSize,
              enterpriseId: this.searchEnterpriseId,
              taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
              keyword: this.searchKeyword,
              status: this.searchStatus,
              enterpriseTypeId: this.searchEnterpriseTypeId
            }
          });
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/customers'], {
        queryParams: {
          tenantId: this.searchtenantId,
          page: this.searchPage,
          pageSize: this.searchPageSize,
          enterpriseId: this.searchEnterpriseId,
          taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
          keyword: this.searchKeyword,
          status: this.searchStatus,
          enterpriseTypeId: this.searchEnterpriseTypeId
        }
      });
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.uploadMultiFileComponent.isFormChanging && this.show && tenantId != null)
      || (this.change && this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.change = true;
  }


  /**
   * Get wards list from local storage or api
   */
   getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
        this.filteredBankName.next(this.listBankName.slice());
      }
    });
  }

  /**
   * Get wards list from local storage or api
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.certificateType = result;
        this.filteredCertificationType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
    });
  }

  onAttachmentChange(event) {
    this.isFormChanging = event;
  }

  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  onChangeType() {
    if (this.oldCustomerType == 10000 && this.customer.customerType > 10000 || this.customer.customerType == 10000 && this.oldCustomerType > 10000) {
      this.customer.taxCode = '';
      this.customer.certificateId = null;
      this.isDisableLGT = false;
      this.isDisableMST = false;
    }
    this.oldCustomerType = this.customer.customerType;
  }

  onChangeGroupCustomerIds(event) {
    this.groupCustomerIds = event;
    this.isFormChanging = true
  }

  originGroupCustomerIds(event) {
    if (event && event.length) {
      event.map(item => this.customer.groupCustomerIds.push(item.id));
    }
  }

  isInvalidForm() {
    this.accordion.openAll();
    this.myTabGroup.selectedIndex = 0;
    this.ngForm.form.markAllAsTouched();
    this.ngForm.form.markAsDirty()
  }

  cutSpace() {
    this.customer.customerCode = this.customer.customerCode.replace(/\s/g, '')
  }

  checkDisplayConfigCustomer() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(401)) {
      return true;
    }
    if(this.permissions.includes(403)) {
      return true;
    }
    if(this.permissions.includes(404)) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnUpdate() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(401)) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(403) && (this.isInforTab == 0 || this.isInforTab == 1)) {
      return true;
    }
    return false;
  }

  changeAddress(event: boolean){
    if(this.customer.isNewAddress == event){
      return
    }
    this.customer.isNewAddress = event
    console.log(event);

    if(event){
      this.cities = this.cityList[0]
      this.districts = this.districtList[0]
      this.wards = this.wardList[0]
      if(!(!this.customer.cityId && !this.customer.districtId && !this.customer.wardId)){
        this.blockUI.start()
        const id = this.customer.wardId ? this.customer.wardId : this.customer.districtId ? this.customer.districtId : this.customer.cityId
        this.customer.cityId = null
        this.customer.districtId = null
        this.customer.wardId = null
        this.onChange(null, 2)
        this.commonService.changeNewAddress(id).pipe(finalize(()=> this.blockUI.stop())).subscribe(res =>{
          console.log(res, res.data._return.lstProductSpecCharDTOs);
          if(res.success){
            if(res.data._return.lstProductSpecCharDTOs && res.data._return.lstProductSpecCharDTOs.length > 0){
              this.customer.cityId = res.data._return.lstProductSpecCharDTOs[0].province;
              this.onChange(this.customer.cityId, 2)
              if(res.data._return.lstProductSpecCharDTOs[0].precinct){
                this.customer.wardId = this.customer.cityId + res.data._return.lstProductSpecCharDTOs[0].precinct;
              }
            }
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        this.onChange(null, 2)
      }
    } else {
      this.cities = this.cityList[1]
      this.districts = this.districtList[1]
      this.wards = this.wardList[1]
      this.customer.cityId = null
      this.customer.districtId = null
      this.customer.wardId = null
      this.onChange(null)
    }
    this.cityFilterCtrl.patchValue('')
    this.districtsFilterCtrl.patchValue('')
    this.wardFilterCtrl.patchValue('')
  }
}
